import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { ProductContext } from "../../context/ProductContext";
import {
  qualifiesForFreeShipping,
  transportMethods,
} from "../../utils/global_const";
import { useTranslation } from "react-i18next";
import {
  SectionCard,
  SectionHeader,
  SectionTitle,
  SectionBody,
  StepBadge,
  StepBadgeContent,
} from "../checkout/CheckoutSection";

const OptionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-sm);

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }
`;

const OptionCard = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
  border-radius: var(--border-radius-base);
  border: 2px solid
    ${(props) => (props.$selected ? "var(--primary-100)" : "var(--bg-200)")};
  background-color: ${(props) =>
    props.$selected ? "var(--primary-300)" : "var(--bg-100)"};
  cursor: pointer;
  transition: border-color var(--transition-fast),
    background-color var(--transition-fast);

  &:hover {
    border-color: var(--primary-200);
  }
`;

const RadioOuter = styled.div`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid
    ${(props) => (props.$selected ? "var(--primary-100)" : "var(--bg-300)")};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RadioInner = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: var(--primary-100);
`;

const OptionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const OptionName = styled.span`
  font-size: var(--font-size-base);
  color: var(--text-100);
`;

const OptionPrice = styled.span`
  font-size: var(--font-size-small);
  font-weight: 600;
  color: var(--primary-100);
`;

const Transport = () => {
  const { t } = useTranslation();
  const { currencyTag, setShippingMethod } = useContext(ProductContext);
  const [selectedMethod, setSelectedMethod] = useState(transportMethods[0]);

  const cartItems = useSelector((state) => state.cart.itemsList);
  const subtotalRounded = parseFloat(
    cartItems
      .reduce(
        (total, item) => total + item.product.discount_price * item.quantity,
        0
      )
      .toFixed(2)
  );

  useEffect(() => {
    setShippingMethod(selectedMethod);
  }, [selectedMethod]);

  return (
    <SectionCard>
      <SectionHeader>
        <StepBadge $done>
          <StepBadgeContent step={2} done />
        </StepBadge>
        <SectionTitle>{t("TRANSPORT.TITLE")}</SectionTitle>
      </SectionHeader>
      <SectionBody>
        <OptionGrid>
          {transportMethods.map((method) => {
            const isSelected = selectedMethod.name === method.name;
            return (
              <OptionCard
                key={method.name}
                $selected={isSelected}
                onClick={() => setSelectedMethod(method)}
                role="radio"
                aria-checked={isSelected}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setSelectedMethod(method);
                  }
                }}
              >
                <RadioOuter $selected={isSelected}>
                  {isSelected && <RadioInner />}
                </RadioOuter>
                <OptionText>
                  <OptionName>{method.name}</OptionName>
                  <OptionPrice>
                    {qualifiesForFreeShipping(subtotalRounded, method.name)
                      ? t("CART.FREE")
                      : `${currencyTag}${method.price}`}
                  </OptionPrice>
                </OptionText>
              </OptionCard>
            );
          })}
        </OptionGrid>
      </SectionBody>
    </SectionCard>
  );
};

export default Transport;
